import {Component, OnInit, Output, EventEmitter } from '@angular/core';
import {RecommendedVm} from '../../../../view-model/recommended/recommended.vm';
import { saveDataSuggests } from 'src/app/data/actions/utils.actions';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-recommended',
  templateUrl: './recommended.component.html',
  styleUrls: ['./recommended.component.scss'],
})
export class RecommendedComponent implements OnInit {
  customer;
  @Output() recommendedItem = new EventEmitter<string>();
  @Output() isClose = new EventEmitter<string>();
  productsSuggested: Array<Object> = [];
  dataLoaded = false;
  labels;
  constructor(private vm: RecommendedVm, private store: Store<AppState>) {
  }

  ngOnInit(): void {
    this.hasCustomer();
  }

  hasCustomer() {
    this.vm.hasCustomer().subscribe(customer => {
      if (customer.isAnonymous) {
        this.customer = false;
        this.getUnloggedTags();
        this.getSuggested();
      } else {
        this.customer = customer;
        this.getLoggedTags();
        this.getSuggested();
      }
    });
  }

  getSuggested() {
    this.store.select('utils').subscribe(dataSuggested => {
      if (dataSuggested.items.length > 0) {
        this.productsSuggested = dataSuggested.items;
      } else {
        this.vm.getSuggested().subscribe(dataSuggestedService => {
          this.dataLoaded = true;
          this.productsSuggested = dataSuggestedService;
          this.store.dispatch(saveDataSuggests({items: dataSuggestedService}));
        });
      }
    });
  }

  getLoggedTags() {
    if (this.customer) {
    const id = this.getBrazeUserId();
    this.vm.getlastItemViewed(id).subscribe(data => {
      this.labels = data?.users[0]?.custom_attributes['Last items names viewed'];
    });
    }
  }

  getUnloggedTags() {
    this.vm.getAdvertisedItems().subscribe(data => {
      this.labels = data;
    });
  }

  getBrazeUserId(){
    return this.vm.getBrazeId();
  }

  searchLabel(item) {
    this.recommendedItem.emit(item);
  }

  onClickedOutside() {
    this.isClose.emit();
  }
}

export class RecommendedModule {}
